import { useRoute } from "vue-router/composables";
import _ from 'lodash'
import { IMenuItem } from "@/view_helper/mainMenu";
import { Route } from "vue-router";


export function hasSubActive(route: Route, menu: IMenuItem) {
    const childRoutes = new Set<string>()
    function collectRoutes(menu: IMenuItem) {
        if (menu.router) {
            childRoutes.add(menu.router)
        }
        _.each(menu.children, collectRoutes)
    }
    _.each(menu.children, collectRoutes)
    const isSubActive = _.some(route.matched, x => childRoutes.has(x.name))
    return isSubActive
}


export function useMenu() {
    const route = useRoute()
    return {
        hasSubActive(menu: IMenuItem) {
            return hasSubActive(route, menu)
        }
    }
}
